import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchInternalsOrdersList = ({client, order, warehouse}, withDetail) => {
  const clientFilter = client ? `&client=${client}` : '';
  const orderFilter = order ? `&order=${order}` : '';
  const warehouseFilter = warehouse ? `&warehouse=${warehouse}` : '';
  const withDetailFilter = withDetail ? `&withDetail=${withDetail}` : '';

  return apiActionCreator({
    'endpoint': `/orders/internals?${clientFilter}${orderFilter}${warehouseFilter}${withDetailFilter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_INTERNALS_ORDERS_LIST,
      ActionTypes.FETCHED_INTERNALS_ORDERS_LIST,
      [
        ActionTypes.FETCHED_INTERNALS_ORDERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const changeInternalsOrdersListPage = (value) => ({
  'type': ActionTypes.CHANGE_INTERNALS_ORDERS_LIST_PAGE,
  'payload': value,
});

export const changeInternalsOrdersListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_INTERNALS_ORDERS_LIST_PAGE_SIZE,
  'payload': value,
});

export const emptyOrdersData = () => ({
  'type': ActionTypes.EMPTY_ORDERS_DATA,
});

export const deleteInternalOrder = (orderCode, returnToList) => apiActionCreator({
  'endpoint': `/orders/internals/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_INTERNAL_ORDER,
    [
      {
        'type': ActionTypes.DELETED_INTERNAL_ORDER,
        'payload': {orderCode, returnToList},
      },
      MessageActions.addMessageBoxInfo('Pedido interno eliminado satisfactoriamente'),
    ],
    [
      ActionTypes.DELETED_INTERNAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': {'action': 'reject'},
});

export const createInternalOrder = (data) => apiActionCreator({
  'endpoint': '/orders/internals',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_INTERNAL_ORDER,
    [
      ActionTypes.CREATED_INTERNAL_ORDER,
      MessageActions.addMessageBoxInfo('Pedido interno creado satisfactoriamente'),
    ],
    [
      ActionTypes.CREATED_INTERNAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const clearInternalOrderForm = () => ({
  'type': ActionTypes.CLEAR_INTERNAL_ORDER_FORM,
});

export const fetchInternalOrder = (orderCode) => apiActionCreator({
  'endpoint': `/orders/internals/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INTERNAL_ORDER,
    ActionTypes.FETCHED_INTERNAL_ORDER,
    [
      ActionTypes.FETCHED_INTERNAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const verifyStockInWarehouse = (warehouse, partCode, index) => apiActionCreator({
  'endpoint': `/transactions/warehouses/${warehouse}/parts/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.VERIFYING_STOCK_IN_WAREHOUSE,
    {
      'type': ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE,
      'payload': index,
    },
    [
      {
        'type': ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE_FAILED,
        'payload': index,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateSubtotal = (index, quantity, price) => ({
  'type': ActionTypes.UPDATE_SUBTOTAL,
  'payload': {index, quantity, price},
});

export const addItemToInternalOrder = (index, orderCode, data) => apiActionCreator({
  'endpoint': `/orders/internals/${orderCode}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_ITEM_TO_INTERNAL_ORDER,
    [
      {
        'type': ActionTypes.ADDED_ITEM_TO_INTERNAL_ORDER,
        'payload': index,
      },
    ],
    [
      ActionTypes.ADDED_ITEM_TO_INTERNAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const deleteItemFromInternalOrder = (index, orderCode, data) => apiActionCreator({
  'endpoint': `/orders/internals/${orderCode}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_ITEM_FROM_INTERNAL_ORDER,
    [
      {
        'type': ActionTypes.DELETED_ITEM_FROM_INTERNAL_ORDER,
        'payload': index,
      },
      MessageActions.addMessageBoxInfo('Item eliminado satisfactoriamente del pedido'),
    ],
    [
      ActionTypes.DELETED_ITEM_FROM_INTERNAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': data,
});

export const updateItemValueFromInternalOrder = (index, {value, name}) => ({
  'type': ActionTypes.UPDATE_ITEM_VALUE_FROM_INTERNAL_ORDER,
  'payload': {index, value, name},
});
